// copied from https://github.com/kvz/locutus/blob/master/src/php/datetime/strtotime.js
import {formats, resultProto} from './strtotimeFormats';

function strtotime(str: string, now?: any): number
{
    //       discuss at: https://locutus.io/php/strtotime/
    //      original by: Caio Ariede (https://caioariede.com)
    //      improved by: Kevin van Zonneveld (https://kvz.io)
    //      improved by: Caio Ariede (https://caioariede.com)
    //      improved by: A. Matías Quezada (https://amatiasq.com)
    //      improved by: preuter
    //      improved by: Brett Zamir (https://brett-zamir.me)
    //      improved by: Mirko Faber
    //         input by: David
    //      bugfixed by: Wagner B. Soares
    //      bugfixed by: Artur Tchernychev
    //      bugfixed by: Stephan Bösch-Plepelits (https://github.com/plepe)
    // reimplemented by: Rafał Kukawski
    //           note 1: Examples all have a fixed timestamp to prevent
    //           note 1: tests to fail because of variable time(zones)
    //        example 1: strtotime('+1 day', 1129633200)
    //        returns 1: 1129719600
    //        example 2: strtotime('+1 week 2 days 4 hours 2 seconds', 1129633200)
    //        returns 2: 1130425202
    //        example 3: strtotime('last month', 1129633200)
    //        returns 3: 1127041200
    //        example 4: strtotime('2009-05-04 08:30:00+00')
    //        returns 4: 1241425800
    //        example 5: strtotime('2009-05-04 08:30:00+02:00')
    //        returns 5: 1241418600

    if (now == null)
    {
        now = Math.floor(Date.now() / 1000);
    }
    else if (now instanceof Date)
    {
        now = now.getTime() / 1000;
    }

    // the rule order is important
    // if multiple rules match, the longest match wins
    // if multiple rules match the same string, the first match wins
    const rules = [
        formats.yesterday,
        formats.now,
        formats.noon,
        formats.midnightOrToday,
        formats.tomorrow,
        formats.timestamp,
        formats.firstOrLastDay,
        formats.backOrFrontOf,
        // formats.weekdayOf, // not yet implemented
        formats.timeTiny12,
        formats.timeShort12,
        formats.timeLong12,
        formats.mssqltime,
        formats.timeShort24,
        formats.timeLong24,
        formats.iso8601long,
        formats.gnuNoColon,
        formats.iso8601noColon,
        formats.americanShort,
        formats.american,
        formats.iso8601date4,
        formats.iso8601dateSlash,
        formats.dateSlash,
        formats.gnuDateShortOrIso8601date2,
        formats.gnuDateShorter,
        formats.dateFull,
        formats.pointedDate4,
        formats.pointedDate2,
        formats.dateNoDay,
        formats.dateNoDayRev,
        formats.dateTextual,
        formats.dateNoYear,
        formats.dateNoYearRev,
        formats.dateNoColon,
        formats.xmlRpc,
        formats.xmlRpcNoColon,
        formats.soap,
        formats.wddx,
        formats.exif,
        formats.pgydotd,
        formats.isoWeekDay,
        formats.pgTextShort,
        formats.pgTextReverse,
        formats.clf,
        formats.year4,
        formats.ago,
        formats.dayText,
        formats.relativeTextWeek,
        formats.relativeText,
        formats.monthFullOrMonthAbbr,
        formats.tzCorrection,
        formats.dateShortWithTimeShort12,
        formats.dateShortWithTimeLong12,
        formats.dateShortWithTimeShort,
        formats.dateShortWithTimeLong,
        formats.relative,
        formats.whitespace,
    ];

    let result = Object.create(resultProto);

    while (str.length)
    {
        let longestMatch = null;
        let finalRule    = null;

        for (let i = 0, l = rules.length; i < l; i++)
        {
            const format = rules[i];

            const match = str.match(format.regex);

            if (match)
            {
                if (!longestMatch || match[0].length > longestMatch[0].length)
                {
                    longestMatch = match;
                    finalRule    = format;
                }
            }
        }

        // @ts-ignore
        if (!finalRule || (finalRule.callback && finalRule.callback.apply(result, longestMatch) === false))
        {
            return 0;
        }

        str          = str.substr(longestMatch![0].length);
        finalRule    = null;
        longestMatch = null;
    }

    return Math.floor(result.toDate(new Date(now as number * 1000)) / 1000);
}

export {
    strtotime,
};
